// Module
var code = "<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m16.59 47.17c-1.21 0-2.37-.55-3.13-1.5l-12.35-15.47c-1.38-1.73-1.1-4.24.63-5.62s4.24-1.09 5.62.63l9.05 11.34 24.42-33.98c1.29-1.79 3.79-2.2 5.58-.91s2.2 3.79.91 5.58l-27.5 38.27c-.73 1.02-1.9 1.63-3.15 1.66-.03 0-.07 0-.1 0z\"/></svg>";
// Exports
module.exports = code;